import {useEffect} from 'react';

import {useDispatch} from 'react-redux';

import {hideLoading, showLoading} from '@/actions/loadingStateAction';
import {showWarningToast} from '@/actions/toastStateAction';
import {getHubsConnected} from '@/websocket/signalRManager';

import useIntlFormat from './useIntlFormat';

function useHubInitConnection(cb) {
  const dispatch = useDispatch();
  const {formatMessage} = useIntlFormat();

  useEffect(() => {
    const waitingHubReady = (cb) => {
      const intervalDelay = 100;
      const timeOut = 90000; // time limit
      let i = 0;

      const waitInterval = setInterval(() => {
        const isAllConnected = getHubsConnected();
        const timeElapsed = intervalDelay * i;

        // All hubs are connected or reach time limit.
        if (isAllConnected || timeElapsed >= timeOut) {
          console.log('waitingHubReady timeElapsed:', timeElapsed);
          console.log('waitingHubReady isAllConnected:', isAllConnected);

          clearInterval(waitInterval);
          if (cb) {
            setTimeout(() => {
              cb(isAllConnected);
            }, 600);
          }
        }
        i++;
      }, intervalDelay);
    };
    dispatch(showLoading());
    waitingHubReady((isConnected) => {
      if (isConnected) {
        // Initialize available labware state.
        dispatch(hideLoading());
        if (cb) cb();
      } else {
        const msg = formatMessage({id: 'loading.hub.connectionClosed.message'});
        dispatch(showLoading(msg));
        dispatch(showWarningToast(msg));
        throw Error(msg);
      }
    });
    return () => {
      // TO-DO: Create unmount.
    };
  }, [dispatch, formatMessage, cb]);
}
export default useHubInitConnection;
